import { gql } from '@apollo/client';
import client from 'graphql/client';

const fetchListsGraphql = () => {
  const params = {};

  const query = gql`
    query lists {
      lists {
        cities {
          id
          name
        }
        regions {
          id
          name
        }
      }
    }
  `;

  return client.query({
    query,
    ...params,
  });
};

const fetchCandidateSearchListsGraphql = () => {
  const query = gql`
    query lists {
      lists {
        cities {
          id
          name
        }
        regions {
          id
          name
        }
        standardizedPositions {
          id
          name
        }
        categories {
          id
          name
        }
        educationCategories {
          id
          name
        }
        educationLevels {
          id
          name
        }
        languages {
          id
          name
        }
        languageProficiencies {
          id
          name
        }
        computerSkills {
          id
          name
        }
        positionExperiences {
          id
          name
        }
        skillLevels {
          id
          name
        }

        driversLicenses {
          id
          name
        }
        licenses {
          id
          name
        }
        skillLevels {
          id
          name
        }
        languageProficiencies {
          id
          name
        }
        skills {
          id
          name
        }
      }
    }
  `;

  return client.query({
    query,
    fetchPolicy: 'cache-first',
  });
};

export default fetchListsGraphql;
export { fetchCandidateSearchListsGraphql };
